"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCurrency = exports.supportedCurrency = void 0;
exports.supportedCurrency = {
    RUB: "₽",
    KZT: "₸",
};
/**
 * Дефолтное значение валюты (если не передано)
 */
exports.defaultCurrency = "RUB";
